export default {
    title:
      "EBC Financial Group Partners with University of Oxford to Shape Global Economics",
    description:
      "Discover how EBC Financial Group and the University of Oxford unite to align research with real-world finance and global economic solutions.",
    word1:
      "EBC Financial Group and the University of Oxford’s Department of Economics",
    word2:
      "Bridging research and reality to reshape how we navigate the global economy",
    word3: "View Our Highlights",
    word4: "Partner With Us!",
    word5: "Overview",
    word6: "Past Episodes of WERD",
    word7: "Special Guests",
    word8: "In the News",
    word9: "It All Started With A Simple Idea: Education Empowers",
    word10:
      "At EBC Financial Group, we believe responsible finance starts with accessible knowledge. That’s why we’ve partnered with the University of Oxford’s Department of Economics to bring world-class research to real-world audiences.\n ",
    word11:
      "Through the What Economists Really Do (WERD) series, we’re advancing financial literacy, sparking critical dialogue, and empowering the next generation of investors, leaders, and thinkers.",
    word12:
      "Rooted in our values of fairness, responsibility, and integrity, this collaboration reflects our ongoing commitment to a more informed, inclusive financial future.",
    word13: "Real Conversations, Real Impact",
    word14: "1st WERD Episode:",
    word15: "The Economics of Tax Evasion  ",
    word16: "Details",
    word17:
      "Explored the impact of tax evasion on both global and local economies, highlighting the importance of financial literacy in addressing complex economic issues  ",
    word18: "Speakers",
    word19: "Dr. Abi Adams, Professor of Economics, University of Oxford & Associate Head (External Engagement), Department of Economics",
    word20:
      "Dr. Sarah Clifford, Professor of Economics, University of Oxford",
    word21:
      "David Barrett, CEO of EBC Financial Group (UK) Ltd as the official guest speaker ",
    word22: "Date",
    word23: "March 2024",
    word24: "(What Economists Really Do 2023-2024 edition) ",
    word25: "Format",
    word26: "Zoom Recording",
    word27: "2nd WERD Episode:",
    word28:
      "Sustaining Sustainability: Balancing Economic Growth and Climate Resilience",
    word29:
      "Explored how macroeconomic policies can help address some of the world’s most urgent environmental challenges while ensuring economic stability",
    word30:
      "Dr. Banu Demir Pakel, Professor of Economics, Session Moderator",
    word31: "Dr. Andrea Chiavari, Professor of Economics, Keynote Speaker",
    word32:
      "Dr. Nicola Ranger, Director of the Global Finance and Economy Group and Resilient Planet Finance Lab, Oxford",
    word33: "David Barrett, our CEO at EBC Financial Group (UK) Ltd ",
    word34: "November 2024\n(What Economists Really Do 2024-2025 edition) ",
    word35:
      "First WERD event to feature a dedicated panel discussion session in a hybrid setting ",
    word36: "Our Guest Speakers",
    word37: "Nicola Ranger",
    word38:
      "Head of Environmental Resilience and Martin Systems at the University of Oxford",
    word39:
      "Nicola Ranger leads Environmental Resilience and Martin Systems Resilience at the University of Oxford. She founded the Global Finance and Economics Group at the Environmental Change Institute, collaborating with financial institutions and governments to advance research at the intersection of finance and climate. Ranger has developed stress testing methods with the IMF, World Bank, NGFS, and the UK Climate Financial Risk Forum. She also advises the EU Commission's EMDE Sustainable Investment High-Level Expert Group, the UK Green Tech (Taxonomy) Advisory Group/LNAS, FCDO, and the London School of Economics.",
    word40: "Andrea Chiavari",
    word41: "Associate Professor of Economics at the University of Oxford",
    word42:
      "Andrea Chiavari is an associate professor at the University of Oxford's Department of Economics, specialising in macroeconomics with a focus on corporate dynamics and technological change. He explores how economic models can foster sustainable development, studying climate change's impact on corporate productivity and capital allocation, while enhancing economic efficiency and resilience in uncertain environments.\n",
    word43: "Banu Demir Pakel",
    word44: "Associate Professor of Economics at the University of Oxford",
    word45:
      "Banu is an associate professor of economics at the University of Oxford, specialising in the intersection of international trade and development economics. Her research examines how firms adjust to trade-related shocks and how these adjustments influence aggregate economic outcomes like growth and income. She is a research affiliate of the CEPR (International Trade and Regional Economics Programme) and an affiliate of the CESifo Research Network in Munich.\n",
    word46: "David Barrett",
    word47: "CEO of EBC Financial Group (UK) Ltd",
    word48:
      "David is the CEO of EBC Financial Group (UK) Ltd, with over thirty-five years of experience in Foreign Exchange, Fixed Income, Commodities, Derivatives, and CFDs. While he has spent much of his career in Tier One Institutions, he has also specialised in building and restructuring smaller businesses. This background has equipped him with extensive knowledge in strategy, business management, product development, derivative structuring, funding, and oversight in these areas. ",
    word49: "Sarah Clifford",
    word50:
      "Associate Professor of Economics, Department of Economics, the University of Oxford",
    word51:
      "Dr. Sarah Clifford, a leading expert in 'tax avoidance economics' at the University of Oxford, explores the economic principles behind tax avoidance and related behavior models. She was among the first to use multinational panel data to study MNE effective tax rates and played a key role in developing the OECD’s 'GloBE' proposal on base erosion, significantly advancing the BEPS framework. Her latest paper examines the global impact of tax avoidance and how effective policy interventions can mitigate this issue.",
    word52: "Abi Adams-Prassl",
    word53:
      "Professor of Economics, Nuffield College, Associate Head (External Engagement)",
    word54:
      "Professor Abi Adams-Prassl specialises in applied microeconomics, using empirical methods to integrate data into decision models for individuals and households. As a member of the UK Government's Office for Science, she led initiatives on risk management and resilience planning, extending short-term measures into long-term strategies. Additionally, she has developed a quantitative framework for the UK legal system, balancing judicial access and transparency in the era of big data.",
    word55: "Find Out More",
    word56: "In The News",
    word57: "Let’s Build the Next Chapter Together.",
    word58:
      "EBC is actively exploring new collaborations with\nlike-minded institutions and change-makers.",
    word59: "Contact Us",
    placeholder1: "Full Name",
    placeholder2: "Email Address",
    placeholder3: "Mobile",
    placeholder4: "Verification Code",
}
